import { composeIO } from 'react-compose-io'
import { DetalheInadimplenciaView } from './DetalheInadimplencia.View'
import { detalheInadimplenciaIO } from './DetalheInadimplencia.IO'

export const DetalheInadimplencia = composeIO(DetalheInadimplenciaView, detalheInadimplenciaIO)
